import {
  Button,
  Dialog,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  Spinner
} from "@fluentui/react-components";
import { Dismiss24Regular } from "@fluentui/react-icons";
import { useState } from "react";
import { useGetTechnicalAccountManager } from "../../apis/CustomerManagementApi";
import { useGetTenantName } from "../../apis/GraphApi";
import { AppCard } from "./AppCard";

export type DigitalTransformationAppCardProps = {
  className?: string;
  img: string;
  allowed?: boolean,
}

export const DigitalTransformationAppCard = (props: DigitalTransformationAppCardProps) => {
  const [open, setOpen] = useState(false);
  const { data: companyName } = useGetTenantName();
  const { data: technicalManager } = useGetTechnicalAccountManager();

  return (
    <>
      <AppCard className={props.className}
        title="Digital Transformation Call"
        description="Transform Your IT Strategy with Monthly Expert Guidance!"
        img = {props.img}
        onClick={() => setOpen(true)}
        allowed={props.allowed}
      />
      <Dialog open={open}>
        <DialogSurface>
          <DialogBody>
            <DialogTitle
              action={
                <Button
                  appearance="subtle"
                  aria-label="close"
                  onClick={() => setOpen(false)}
                  icon={<Dismiss24Regular />}
                />
              }
            >
              Service Description
            </DialogTitle>
            <DialogContent style={{textAlign: "justify"}}>
              {(!companyName || !technicalManager) ? <Spinner size="large"/> :
              <>
                <p>Our <strong>Monthly Digital Transformation call</strong> service is designed to help our Clients set, define, and achieve their strategic IT goals, like transitioning from on-prem AD to Azure AD, implementing Microsoft Intune for Autopilot and Zero-touch Deployment, migrating to Teams Phone System, etc. This service includes a monthly call with a Microsoft 365 expert to discuss progress, identify areas for improvement, and provide guidance on how to leverage the full capabilities of Microsoft 365 to achieve those goals. We will also provide updates on the latest advancements in Microsoft 365 and provide guidance on how to leverage those features to improve productivity, enhance security, and streamline processes. We will also discuss plans for the next month and create and assign tasks for all involved parties.</p>
                
                <p>In addition, this includes customized solutions tailored to the specific needs of each organization. We will work closely with our clients to identify areas where customized solutions can help achieve strategic goals more efficiently and effectively.</p>
                
                <p>The service can also provide numerous benefits to organizations, including staying up-to-date with the latest technology advancements, improving productivity, enhancing security, increasing efficiency, and reducing costs. With regular check-ins and guidance from our Microsoft 365 experts, organizations can achieve their strategic goals and position themselves for long-term success.</p>

                <p><strong>Ready to start your transformation? <a href={`mailto:${technicalManager?.email}?subject=Digital%20Transformation%20Call%20Demo%20Inquiry&body=Hello%20${technicalManager?.displayName},%0D%0A%0D%0AWe%20are%20${companyName}%20and%20are%20interested%20in%20learning%20more%20about%20the%20Monthly%20Digital%20Transformation%20Call.%0D%0A%0D%0APlease,%20provide%20us%20with%20additional%20details%20or%20schedule%20a%20demo.`}>Contact your Technical Account Manager</a> to schedule your call!</strong></p>
              </>}
            </DialogContent>
          </DialogBody>
        </DialogSurface>
      </Dialog>
    </>
  );
};